export default "__VITE_ASSET__qlJI7SlP__"